import * as React from 'react';

import { IServiceProps, Service } from '../Service';

type TStaticProps = 'subTitle' | 'bgColor' | 'icon' | 'description' | 'dataName';
type TStaticPropsWithTitle = 'title' | TStaticProps;

export type IServiceStaticProps = Pick<IServiceProps, TStaticPropsWithTitle>;
export type IServiceDynamicProps = Omit<IServiceProps, TStaticProps>;

export const createService = (staticProps: IServiceStaticProps): React.FunctionComponent<IServiceDynamicProps> =>
  function ServiceWrapper(dynamicProps) {
    return <Service {...dynamicProps} {...staticProps} />;
  };
